import styled from '@emotion/styled';
import { Tooltip } from '@material-ui/core';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Save from '@material-ui/icons/Save';
import Undo from '@material-ui/icons/Undo';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import ButtonWithIcon from '../../../../component/primitive/ButtonWithIcon';
import { SPACING_REGULAR, SPACING_UNIT } from '../../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../../styleUtility/flexibleLayout';
import mq from '../../../../styleUtility/mediaquery';

type Props = {
  onClickBackButton: () => void;
  onClickNextButton: () => void;
  onClickSaveAsDraftButton: () => void;
  isStateValid: boolean;
  isFlat: boolean;
  hasOption: boolean;
};

const CreativeBriefActions: FC<Props> = ({
  onClickBackButton,
  onClickNextButton,
  onClickSaveAsDraftButton,
  isStateValid,
  isFlat,
  hasOption,
}) => {
  return (
    <Actions>
      <Buttons>
        {!isFlat && (
          <ButtonWithIcon icon={Undo} color="default" variant="contained" onClick={onClickBackButton}>
            <FormattedMessage id="project_editing_page.creative_brief.buttons.back" />
          </ButtonWithIcon>
        )}
        <ButtonWithIcon icon={Save} color="default" variant="contained" onClick={onClickSaveAsDraftButton}>
          <FormattedMessage id="project_editing_page.creative_brief.buttons.save_as_draft" />
        </ButtonWithIcon>
        <FormattedMessage id="project_editing_page.for_filling_out.helper_text">
          {(txt: string) => (
            <Tooltip
              placement="top"
              title={txt}
              disableFocusListener={!isStateValid}
              disableHoverListener={!isStateValid}
              disableTouchListener={!isStateValid}
            >
              <ButtonWithIcon
                icon={ArrowForward}
                variant="contained"
                color="primary"
                disabled={!isStateValid}
                onClick={onClickNextButton}
              >
                {hasOption ? (
                  <FormattedMessage id="project_editing_page.creative_brief.buttons.go_forward" />
                ) : (
                  <FormattedMessage id="project_editing_page.creative_brief.buttons.submit" />
                )}
              </ButtonWithIcon>
            </Tooltip>
          )}
        </FormattedMessage>
      </Buttons>
    </Actions>
  );
};

const Actions = styled.div`
  ${flexibleLayoutContainer({
    justifyContent: 'flex-end',
  })}
  margin-top: 46px;

  ${mq('sp')} {
    margin-top: ${SPACING_REGULAR}px;
  }
`;

const Buttons = styled.div`
  > button {
    margin-left: ${SPACING_UNIT}px;
  }

  ${mq('sp')} {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    margin-top: ${SPACING_REGULAR}px;

    > button {
      margin-bottom: ${SPACING_UNIT}px;
      margin-left: 0;
    }
  }
`;

export default CreativeBriefActions;
